import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import LoaderGif from "../assets/pmiic_Loader.gif";
import SpinnerLoaderGif from "../assets/spinner1.gif";
import SpinnerLoaderGif2 from "../assets/spinner2.gif";
import { Spinner } from "react-bootstrap";
import generate from "../assets/generate.png";
import loaderGIF from "../assets/loader1.gif";

export const LoaderPage = ({ className, children, loading }) => {
  return loading ? (
    <div className={`${className} loader`}>
      <img src={LoaderGif} alt="Loader" />
    </div>
  ) : (
    <div>{children}</div>
  );
};

export const AILoader = ({ className, children, loading }) => {
  return loading ? (
    <div className={`loader`}>
      {/* <div className="star-loader" /> */}
      <div className="loader-AI">
        <img
          style={{ width: "48px", left: "41%", top: "39.5%" }}
          src={loaderGIF}
        />
        <img
          src={generate}
          style={{ width: "222px", left: "45%", top: "41.5%" }}
        />
      </div>
    </div>
  ) : (
    <div>{children}</div>
  );
};

export const NotificationLoaderPage = ({ children, loading }) => {
  return loading ? <div className={`loader`} /> : <div>{children}</div>;
};

export const MigrationLoaderPage = ({
  className,
  children,
  loading,
  setLoading
}) => {
  const [animateReady, setAnimateReady] = useState(false);

  useEffect(() => {
    let animateTimer, loadingTimer;

    if (loading) {
      animateTimer = setTimeout(() => {
        setAnimateReady(true);
      }, 60000);

      loadingTimer = setTimeout(() => {
        setLoading(false);
      }, 61000);
    } else {
      // Reset animateReady to false when loading is complete
      setAnimateReady(false);
    }

    return () => {
      clearTimeout(animateTimer);
      clearTimeout(loadingTimer);
    };
  }, [loading, setLoading]);
  return loading ? (
    <div className={`${className} loader`}>
           {" "}
      <div className={`${animateReady ? "image-to-animate" : "normal-loader"}`}>
                <img src={LoaderGif} alt="Loader" />
             {" "}
      </div>
            <span className="text">Migration is in progress...</span>   {" "}
    </div>
  ) : (
    <div>{children}</div>
  );
};

NotificationLoaderPage.propTypes = {
  className: PropTypes.string,
  children: PropTypes.object,
  loading: PropTypes.bool
};

NotificationLoaderPage.defaultProps = {
  className: "",
  loading: false
};

MigrationLoaderPage.propTypes = {
  className: PropTypes.string,
  children: PropTypes.object,
  loading: PropTypes.bool
};

MigrationLoaderPage.defaultProps = {
  className: "",
  loading: false
};

LoaderPage.propTypes = {
  className: PropTypes.string,
  children: PropTypes.object,
  loading: PropTypes.bool
};

LoaderPage.defaultProps = {
  className: "",
  loading: false
};

AILoader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.object,
  loading: PropTypes.bool
};

AILoader.defaultProps = {
  className: "",
  loading: false
};

export const LoaderElement = ({ className, children, loading }) => {
  return loading ? (
    <div className="p-relative">
      <div className={`${className} loadingIndicator`}>
        <span className="loadingIndicator--child-1" />
        <span className="loadingIndicator--child-2" />
        <span className="loadingIndicator--child-3" />
      </div>
    </div>
  ) : (
    <div>{children}</div>
  );
};

LoaderElement.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool
};

LoaderElement.defaultProps = {
  className: "",
  loading: false
};

export const LoaderOverlay = ({
  className,
  children,
  loading,
  loadingPercent
}) => {
  return (
    <>
      {loading ? (
        <>
          <hr />

          {loadingPercent == 0 ? (
            <>
              <div className="uploading-progress-bar">
                <div className="progress" id="loading-progress">
                  <div className="progress-bar" style={{ maxWidth: "100%" }}>
                    Processing...
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="uploading-progress-bar">
                <div className="progress" id="loading-progress">
                  <div
                    className="progress-bar"
                    style={{ maxWidth: loadingPercent + "%" }}
                  >
                    {loadingPercent < 100
                      ? "Uploading" + loadingPercent + "%"
                      : "Processing..."}
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      ) : null}
    </>
  );
};

LoaderOverlay.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool
};

LoaderOverlay.defaultProps = {
  className: "",
  loading: false
};

export const LoaderOverlayNewsLetter = ({
  className,
  children,
  loading,
  loadingPercent,
  newsLetter = false
}) => {
  return (
    <>
      {loading ? (
        <>
          <hr />

          {loadingPercent == 0 && window.location.pathname != "/cms" ? (
            <>
              <div className="uploading-progress-bar">
                <div className="progress" id="loading-progress">
                  <div className="progress-bar" style={{ maxWidth: "100%" }}>
                    Processing...
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="uploading-progress-bar">
                <div className="custom-progress">
                  <div
                    className="custom-progress-fill"
                    style={{
                      width: `${loadingPercent}%`,
                      transition: "width 0.4s ease"
                    }}
                  />

                  <div className="custom-progress-text">
                    {loadingPercent < 100
                      ? `Uploading ${Number(loadingPercent).toFixed(0)}%`
                      : "Uploading 0%"}
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      ) : null}
    </>
  );
};

LoaderOverlayNewsLetter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool
};

LoaderOverlayNewsLetter.defaultProps = {
  className: "",
  loading: false
};

export const TableLoaderComp = ({ className, loading }) => {
  return loading ? (
    <div className={`${className} loader`}>
      <div>
        <img src={LoaderGif} alt="Loader" className="gif-loader" />
      </div>
    </div>
  ) : null;
};

TableLoaderComp.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool
};

TableLoaderComp.defaultProps = {
  className: "",
  loading: false
};

export const Loader = styled(LoaderPage)`
  &.loader {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const TableLoader = styled(TableLoaderComp)`
  &.loader {
    height: 100%;
    width: 100%;
    padding-top: 50px;
    display: flex;
    justify-content: center;
    position: absolute;
    background-color: rgba(255, 255, 255, 0.5);
    top: 28px;
    min-height: 200px;
  }
`;

export const InnerLoader = ({ className, loading, style }) => {
  return loading ? (
    <div className={`${className} inner-loader`} style={style}>
      <img src={SpinnerLoaderGif} alt="Loader" className="spinner-image" />
    </div>
  ) : null;
};

export const DownloadInnerLoader = ({ className, loading }) => {
  return loading ? (
    <div className={`${className}`}>
      <img src={SpinnerLoaderGif2} alt="Loader" className="spinner-image" />
    </div>
  ) : null;
};

export const UploadSpinner = ({ className, loading }) => {
  return loading ? (
    <div className={`${className}`}>
      <img
        src={SpinnerLoaderGif2}
        alt="Loader"
        className="spinner-image uploadSpiner"
      />
      <div
        style={{
          fontSize: "14px",
          marginTop: "5px"
        }}
      >
        Processing...
      </div>
    </div>
  ) : null;
};
